import Vue from 'vue';
import VModal from 'vue-js-modal';

Vue.use(VModal, { dialog: true });



// WEBPACK FOOTER //
// ./src/plugins/vue-modal.js